import script from "./TextNote.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextNote.vue?vue&type=script&lang=ts&setup=true"

import "./TextNote.vue?vue&type=style&index=0&id=05c7f3a9&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c7f3a9"]])

export default __exports__